import { autoserialize, autoserializeAs } from 'cerialize';
import { environment } from '../../../environments/environment';
import { UserDetailModel } from './user.model';

export class LoginResponseModel {
    @autoserializeAs(UserDetailModel) public user: UserDetailModel;
    @autoserialize public token: string;
}

export class LoginBodyModel {
    @autoserialize private readonly email: string;
    @autoserialize private readonly password: string;
    @autoserialize private readonly teamName?: string;
    private readonly client_id: string;

    constructor(email: string, password: string, teamName?: string) {
        this.email = email;
        this.password = password;
        if (teamName) {
            this.teamName = teamName;
        }
        this.client_id = environment.OAUTH_CLIENT_ID;
    }
}
